<template>
  <div id="app">
    <MuiHeader></MuiHeader>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>  
</template>

<script>
  import MuiHeader from "@/components/MuiHeader";
  export default {
    components: {
      MuiHeader
    },
    name: "app"
  };
</script>



// WEBPACK FOOTER //
// src/App.vue